import { betValueGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { wait } from "../../core/utils";
import { SequentialTask } from "../../core/utils/SequentialTask";
import { IFeatureData, RespinObject, spinData } from "../../server/getServerResposesFun";
import { JackpotIntroBannerComponent } from "../jackpotbanner/JackpotIntroBannerComponent";
import { JackpotWinBannerComponent } from "../jackpotbanner/JackpotWinBannerComponent";
import { MeterComponent } from "../meter/MeterComponent";
import { ReelFrameComponent } from "../reels/ReelFrameComponent";
import { ReelComponent } from "../reels/ReelsComponent";

export class JackpotUpgradeComponent extends AbstractDisplayComponent {
    private featureData: IFeatureData;

    public startFeature(callback?: () => void): Promise<any> {
        const data: RespinObject = spinData.respins[RespinIndex.value];
        this.featureData = data?.featureData;

        if (!this.featureData) {
            console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        }

        let seq = new SequentialTask([
            () => wait(1000),
            () => this.upgradeCurrentJackpotValue(),
            () => this.activateJackpotMeter(),
            () => this.reelUpgrade(),
            () => this.showJackpotIntroBanner(),
            // () => wait(1000),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    private upgradeCurrentJackpotValue() {
        return new Promise<void>(async (resolve) => {
            DisplayComponent.get(MeterComponent).upgradeCurrentJackpotValue(resolve);
        });
    }

    private showJackpotIntroBanner() {
        return new Promise<void>(async (resolve) => {
            DisplayComponent.get(JackpotIntroBannerComponent).play(resolve);
        });
    }

    private activateJackpotMeter() {
        return new Promise<void>(async (resolve) => {
            DisplayComponent.get(MeterComponent).activate(resolve);
        });
    }

    private reelUpgrade(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            const reelHeight = spinData.respins[RespinIndex.value].featureData.reelHeightPerReel;
            DisplayComponent.get(ReelFrameComponent).upgrade(reelHeight, resolve);
            // DisplayComponent.get(ReelComponent).getInstance().animateMask(reelHeight);
            DisplayComponent.get(ReelComponent).getInstance().applyMaskSizeOnly(reelHeight);
        });
    }

    public showBonusCompletedBanner(callback?: () => void): Promise<void> {
        return new Promise<void>((resolve) => {
            const jackpotMultiplier = DisplayComponent.get(MeterComponent).getCurrentWonJackpotValue();
            const jackpotWinAmount = jackpotMultiplier * betValueGlobal;

            DisplayComponent.get(JackpotWinBannerComponent).play(jackpotMultiplier, jackpotWinAmount, () => {
                callback?.();
                resolve();
            });
        });
    }
}